<template>
  <div style="width: 100%">
    <Breadcrumb></Breadcrumb>
    <div class="form-body userList common-limit">
      <div style="overflow: hidden">
        <div class="left">
          <el-button
            v-if="user.userType != '00'"
            type="primary"
            size="small"
            @click="handleAdd"
            >入驻申请</el-button
          >
        </div>
        <pagination
          v-show="total > 0"
          :total="total"
          :page.sync="queryParams.pageNum"
          :limit.sync="queryParams.pageSize"
          @pagination="loadList"
        />
      </div>
      <!-- 表格 -->
      <el-table :data="tableData" class="border">
        <el-table-column
          prop="createTime"
          label="创建时间"
          align="center"
          width="158px"
        ></el-table-column>
        <el-table-column prop="wareState" label="意向国家" align="center">
          <template slot-scope="scope">
            {{ dictMap["amazon_site"][scope.row.wareState] }}
          </template>
        </el-table-column>
        <el-table-column
          label="商家账号"
          prop="operNo"
          align="center"
        ></el-table-column>
        <el-table-column prop="wareAddr" label="意向地址" align="center">
        </el-table-column>
        <el-table-column
          prop="applyNum"
          label="申请平方数"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="name"
          label="联系人"
          align="center"
        ></el-table-column>

        <el-table-column
          prop="mobile"
          label="联系电话"
          align="center"
        ></el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="scope">
            {{ dictMap["auditStatus"][scope.row.applyStatus] }}
          </template>
        </el-table-column>
        <el-table-column
          v-if="user.userType == '00'"
          fixed="right"
          label="操作"
          width="230"
          align="center"
        >
          <template slot-scope="scope">
            <el-button @click="handleUpdate(scope.row)" type="text" size="small"
              >审核</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="queryParams.pageNum"
        :limit.sync="queryParams.pageSize"
        @pagination="loadList"
      />
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :title="title"
      :visible.sync="dialogFormVisible"
      width="800px"
      @close="closeDialog"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="112px"
        :rules="rules"
        class="create-user-form"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="意向国家：" prop="wareState">
              <el-select
                v-if="user.userType != '00'"
                clearable
                filterable
                style="width: 100%"
                size="small"
                v-model="form.wareState"
                placeholder="请选择"
              >
                <template v-for="(value, key) in dictData['amazon_site']">
                  <el-option
                    :key="key"
                    :label="value.label"
                    :value="value.value"
                  ></el-option>
                </template>
              </el-select>
              <span v-else>{{ dictMap["amazon_site"][form.wareState] }}</span>
            </el-form-item>
            <el-form-item label="意向地址：" prop="wareAddr">
              <el-input
                v-if="user.userType != '00'"
                size="small"
                v-model="form.wareAddr"
              ></el-input>
              <span v-else>{{ form.wareAddr }}</span>
            </el-form-item>
            <el-form-item label="申请平方数：" prop="applyNum">
              <el-input
                v-if="user.userType != '00'"
                size="small"
                v-model="form.applyNum"
              ></el-input>
              <span v-else>{{ form.applyNum }}</span>
            </el-form-item>
            <el-form-item label="联系人：" prop="name">
              <el-input
                v-if="user.userType != '00'"
                size="small"
                v-model="form.name"
              ></el-input>
              <span v-else>{{ form.name }}</span>
            </el-form-item>
            <el-form-item label="联系电话：" prop="mobile">
              <el-input
                v-if="user.userType != '00'"
                size="small"
                v-model="form.mobile"
              ></el-input>
              <span v-else>{{ form.mobile }}</span>
            </el-form-item>
            <el-form-item
              prop="applyStatus"
              label="审核结果："
              style="margin-top: 20px"
              v-if="user.userType == '00'"
            >
              <el-radio-group v-model="form.applyStatus">
                <el-radio label="02">通过</el-radio>
                <el-radio label="03">不通过</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <!-- 按钮 -->
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">取 消</el-button>
        <el-button type="primary" @click="submitForm" size="small"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Breadcrumb from "@/components/common/Breadcrumb"
import { allRole } from "@/api/system/role"
import { getShopList } from "@/api/shop/shop"
import { getWareList, addWare, auditWare } from "@/api/mine/ware"
import { listRole } from "@/api/system/role"
import { listSubAccount, addReceive, addShare } from "@/api/system/user"
import { mapGetters } from "vuex"

export default {
  name: "depotApply",
  components: { Breadcrumb },
  data() {
    return {
      // 遮罩层
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      total: 0,
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        userName: "",
        nickName: "",
        phoneNumber: "",
        status: "",
        roleIds: "",
        beginTime: undefined,
        endTime: undefined,
        time: [],
      },
      // 表格
      tableData: [],
      // 表单
      dialogFormVisible: false,
      receivesVisible: false,
      sharesVisible: false,
      title: "",
      form: {
        wareState: "",
        wareAddr: "",
        name: "",
        mobile: "",
        applyNum: "",
        applyStatus: "02",
      },
      formShares: {
        userName: "",
        shares: [],
      },
      statusOptions: [],
      rules: {
        wareState: [{ required: true, message: "不能为空", trigger: "change" }],
        wareAddr: [{ required: true, message: "不能为空", trigger: "blur" }],
        name: [{ required: true, message: "不能为空", trigger: "blur" }],
        mobile: [{ required: true, message: "不能为空", trigger: "blur" }],
        applyNum: [{ required: true, message: "不能为空", trigger: "blur" }],
        applyStatus: [
          { required: true, message: "不能为空", trigger: "change" },
        ],
      },
      filterText: "",
      shop: [],
      roleOption: [],
      shopList: [],
      accountChecks: [],
      childAccountVisible: false,
      accountList: [],
      accountListShow: [],
      checkList: [],
      shareTitle: "设置读取账号",
      activeName: "lazada",
    }
  },
  watch: {
    async childAccountVisible() {
      if (this.childAccountVisible) {
        let result = await listSubAccount()
        let array = []
        result.rows.map((record) => {
          record.checkList = []
          if (record.userName != this.formShares.userName) {
            array.push(record)
          }
        })

        this.accountList = this.accountListShow = array
      }
    },
    filterText: {
      handler() {
        this.accountListShow = this.accountList.filter((record) => {
          if (
            (record.userName &&
              record.userName.indexOf(this.filterText) > -1) ||
            (record.phoneNumber &&
              record.phoneNumber.indexOf(this.filterText) > -1) ||
            (record.nickName && record.nickName.indexOf(this.filterText)) > -1
          ) {
            return true
          }
          return false
        })
      },
      immediate: true,
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
  },
  created() {
    this.getAllRole()
    this.loadList()
    this.getShops()
    this.getDicts("sys_normal_disable").then((response) => {
      this.statusOptions = response.data
    })
  },
  methods: {
    handleShowAccount(title) {
      this.shareTitle = title
      this.accountChecks = []
      this.childAccountVisible = true
    },
    //记载成员列表数据
    getShops() {
      getShopList().then((res) => {
        this.shopList = res.rows
      })
    },
    getRoleName(roles) {
      let array = []
      roles.map((role) => {
        array.push(role.roleName)
      })
      return array.join(",")
    },
    getShopName(shops) {
      let array = []
      shops.map((shop) => {
        array.push(shop.shopName)
      })
      return array.join(",")
    },
    loadList() {
      this.startLoading()
      if (this.queryParams.time) {
        this.queryParams.beginTime = this.queryParams.time[0]
        this.queryParams.endTime = this.queryParams.time[1]
      } else {
        this.queryParams.beginTime = undefined
        this.queryParams.endTime = undefined
      }
      let params = Object.assign({}, this.queryParams)
      delete params["time"]

      getWareList(params).then((res) => {
        this.total = res.total
        res.rows.map((record) => {
          record.userStatus = record.status == "1"
        })
        this.tableData = res.rows
        this.endLoading()
      })
    },
    getAllRole() {
      allRole().then((res) => {
        this.roleOption = res.data
      })
    },
    handleAdd() {
      this.title = "入驻申请"
      this.form = {
        wareState: "",
        wareAddr: "",
        name: "",
        mobile: "",
        applyNum: "",
        applyStatus: "02",
      }
      this.dialogFormVisible = true
    },
    handleSelectAccount(record) {
      record.checkList = ["我的图库", "我的设计", "产品模板", "汇出记录"]
    },
    handleDeleteAccount(record) {
      for (var i = 0; i < this.checkList.length; i++) {
        if (record.userName == this.checkList[i].userName) {
          this.checkList.splice(i, 1)
          break
        }
      }
    },
    handleUnSelectAccount(record) {
      record.checkList = []
    },
    handleUpdate(row) {
      let form = JSON.parse(JSON.stringify(row))
      this.title = "审核申请"
      this.form = form
      this.dialogFormVisible = true
    },
    handleSetReceives(row) {
      let checkList = []
      this.formShares.userName = row.userName
      row.receives.map((record) => {
        let menus = record.menuId ? record.menuId.split(",") : []
        checkList.push({ userName: record.shareNo, checkList: menus })
      })
      this.checkList = checkList
      this.receivesVisible = true
    },
    handleSetShares(row) {
      let checkList = []
      this.formShares.userName = row.userName
      row.shares.map((record) => {
        let menus = record.menuId ? record.menuId.split(",") : []
        checkList.push({ userName: record.receiveNo, checkList: menus })
      })
      this.checkList = checkList
      this.sharesVisible = true
    },

    async handleAddReceive() {
      let form = this.formShares
      let shares = []
      // if (this.checkList.length === 0) {
      //   this.msgError("请选择账号")
      //   return
      // }
      this.checkList.map((record) => {
        shares.push({
          shareNo: record.userName,
          menuId: record.checkList.join(","),
        })
      })
      delete form["shares"]
      form.receives = shares
      await addReceive(form)
      this.receivesVisible = false
      this.loadList()
    },

    async handleAddShare() {
      let form = this.formShares
      let shares = []
      // if (this.checkList.length === 0) {
      //   this.msgError("请选择账号")
      //   return
      // }
      this.checkList.map((record) => {
        shares.push({
          receiveNo: record.userName,
          menuId: record.checkList.join(","),
        })
      })
      delete form["receives"]
      form.shares = shares
      await addShare(form)
      this.sharesVisible = false
      this.loadList()
    },
    handleDelete(row) {
      const userIds = row.userId || this.ids
      this.$confirm("是否确认删除选中的账号吗?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function() {
          return delUser(userIds)
        })
        .then(() => {
          this.loadList()
          this.msgSuccess("删除成功")
        })
        .catch(function() {})
    },
    closeDialog() {
      this.reset()
    },
    closeDialog1() {
      this.filterText = ""
    },
    //提交修改或新增表单
    submitForm() {
      this.$refs["form"].validate(async (valid, msgArr) => {
        let form = this._.clone(this.form)
        if (valid) {
          try {
            let method = addWare
            if (this.title == "审核申请") {
              method = auditWare
            }
            await method(form)
            this.dialogFormVisible = false
            this.loadList()
            this.msgSuccess(
              this.title == "审核申请"
                ? "审核提交成功"
                : "申请提交成功，请等待审核"
            )
          } catch (error) {}
        }
      })
    },
    //取消
    cancel() {
      this.dialogFormVisible = false
      this.reset()
    },
    cancelAccount() {
      this.childAccountVisible = false
      this.filterText = ""
    },
    // 表单重置
    reset() {
      this.form = {
        userId: undefined,
        userName: undefined,
        nickName: undefined,
        password: undefined,
        phoneNumber: undefined,
        status: "0",
        remark: undefined,
        roleIds: [],
        shopIds: [],
        time: [],
      }
      this.resetForm("form")
    },
    resetForm() {
      this.queryParams = Object.assign(this.queryParams, {
        userName: "",
        nickName: "",
        phoneNumber: "",
        status: "",
        roleIds: "",
        beginTime: undefined,
        endTime: undefined,
        time: [],
      })
      this.$refs["form"].resetFields()
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.checkList = selection
    },
    handleSelectionChangeAccount(selection) {
      this.accountChecks = selection
    },
    handleCheckAccount() {
      if (this.accountChecks.length == 0) {
        this.msgError("请选择账号")
        return
      }
      for (let record of this.accountChecks) {
        let find = false
        for (let account of this.checkList) {
          if (account.userName == record.userName) {
            find = true
            break
          }
        }
        if (!find) {
          this.checkList.push({
            userName: record.userName,
            checkList: [],
          })
        }
      }
      this.childAccountVisible = false
    },
    // 用户状态修改
    handleStatusChange(row) {
      let text = row.userStatus ? "启用" : "停用"
      this.$confirm(
        '确认要"' + text + '""' + row.userName + '"用户吗?',
        "警告",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(function() {
          return changeUserStatus(row.userId, row.userStatus ? "1" : "0")
        })
        .then(() => {
          this.msgSuccess(text + "成功")
        })
        .catch(function() {
          row.userStatus = !row.userStatus
        })
    },
    /** 重置密码按钮操作 */
    handleResetPwd(row) {
      this.$prompt('请输入"' + row.userName + '"的新密码', "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        inputPattern: /^\S{6,}$/,
        inputErrorMessage: "密码至少需要6位",
      })
        .then(({ value }) => {
          resetUserPwd(row.userId, value).then((response) => {
            if (response.code === 200) {
              this.msgSuccess("修改成功，新密码是：" + value)
            }
          })
        })
        .catch(() => {})
    },
    handleCheckAllChange(val) {},
    handleCheckedCitiesChange(value) {},
  },
}
</script>
<style scoped>
.create-user-form {
  padding: 10px 30px 0 0;
  overflow: auto;
}
.create-user-form .el-form-item {
  margin-bottom: 15px !important;
}

.userList .el-table--fit {
  border-right: 0 !important;
  border-left: 0 !important;
  border-bottom: 0 !important;
  margin: 3px 0;
}
.create-user-form ::v-deep .el-checkbox:last-of-type {
  margin-right: 30px;
}
.blue {
  color: #4934b2;
  cursor: pointer;
}
</style>

<style lang="scss">
.tablescope {
  .el-switch__label--left {
    position: relative;
    left: 66px;
    color: #fff;
    z-index: -1111;
    white-space: nowrap;
  }
  /*.el-switch__core{*/
  /*width: 50px !important;*/
  /*}*/
  .el-switch__label--right {
    position: relative;
    right: 66px;
    color: #fff;
    z-index: -1111;
    white-space: nowrap;
  }
  .el-switch__label--right.is-active {
    z-index: 1111;
    color: #fff;
  }
  .el-switch__label--left.is-active {
    z-index: 1111;
    color: #595a5a !important;
  }
}
</style>
